var map = {
	"./icon-bootstrap.png": 8451,
	"./icon-chrome-devtools.png": 2416,
	"./icon-css.png": 8528,
	"./icon-cypress.png": 8620,
	"./icon-default.png": 6238,
	"./icon-docker.png": 3593,
	"./icon-express-js.png": 97,
	"./icon-figma.png": 5925,
	"./icon-git.png": 3765,
	"./icon-github.png": 7744,
	"./icon-github.svg": 776,
	"./icon-html.png": 2382,
	"./icon-java.png": 661,
	"./icon-javascript.png": 9896,
	"./icon-jest.png": 4379,
	"./icon-nodejs.png": 1676,
	"./icon-notion.png": 6077,
	"./icon-postgres.png": 4636,
	"./icon-postman.png": 6267,
	"./icon-python.png": 719,
	"./icon-react.png": 9812,
	"./icon-sass.png": 6039,
	"./icon-sql.png": 3513,
	"./icon-trello.png": 3515,
	"./icon-typescript.png": 2880,
	"./icon-zod.png": 7490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;